class ContentTemplate {
	getElement (post) {
		const div = document.createElement('div')
		div.innerHTML = this.getHtml(post)
		return div.firstElementChild
	}

	toggle (event, element) {
		let container = element.parentNode.parentNode.querySelector('.post-row-collection')
		if (container.classList.contains('active')) {
			container.classList.remove('active')
			element.classList.remove('open')
		} else {
			element.classList.add('open')
			container.classList.add('active')
		}
	}

	getHtml (post) {

		const image = post.img ? /* html */ `
			<picture>
				<img src="${post.img}" alt="${post.title}" class="blog-img">
			</picture>
		` : ''
		return /* html */ `
		<div class="col-12">
			<div class = "search-item blog-item-wrapper">
					<a class="blog-title-link" href="${post.link}" title="${post.title}" >
						<h4 class="search-title">${post.title}</h4>
					</a>
					<p class="">${post.text}</p>
				</div>
			</div>
		`
	}
}

const contentTemplate = new ContentTemplate()
export {
	ContentTemplate,
	contentTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/com_catalog_search_async/template/ContentTemplate.js